import {
  createEmptySubButton,
  validateNameLength
} from './button_utils.js'

export default {
  name: 'MenuButtonList',

  props: {
    buttons: {
      type: Array,
      required: true
    },
    selectedPath: {
      type: Object,
      default: null
    },
    limits: {
      type: Object,
      required: true
    },
    isRoot: {
      type: Boolean,
      default: true
    },
    parentPath: {
      type: Object,
      default: null
    }
  },

  methods: {
    pathForIndex(index) {
      if (this.parentPath) {
        return { rootIndex: this.parentPath.rootIndex, childIndex: index }
      }
      return { rootIndex: index }
    },

    isSelected(path) {
      if (!this.selectedPath) {
        return false
      }
      if (path.childIndex != null) {
        return (
          this.selectedPath.rootIndex === path.rootIndex &&
          this.selectedPath.childIndex === path.childIndex
        )
      }
      return (
        this.selectedPath.rootIndex === path.rootIndex &&
        this.selectedPath.childIndex == null
      )
    },

    selectButton(path) {
      this.$emit('select', path)
    },

    removeButton(path, event) {
      event.stopPropagation()
      this.$emit('remove', path)
    },

    canAddSubButton(button) {
      const subCount = (button.sub_button || []).length
      if (!this.limits.max_submenu_length) {
        return true
      }
      return subCount < this.limits.max_submenu_length
    },

    addSubButton(path, event) {
      event.stopPropagation()

      if (this.isRoot) {
        const rootButton = this.buttons[path.rootIndex]
        if (!this.canAddSubButton(rootButton)) {
          Skylark.Bridge.newAlertify(`二级菜单最多${this.limits.max_submenu_length}个!`, { type: 'warning' })
          return
        }
      } else if (this.limits.max_submenu_length && this.buttons.length >= this.limits.max_submenu_length) {
        Skylark.Bridge.newAlertify(`二级菜单最多${this.limits.max_submenu_length}个!`, { type: 'warning' })
        return
      }

      this.$emit('add-sub', path)
    },

    onSortChanged(startIndex, endIndex) {
      this.$emit('sort', { parentPath: this.parentPath, startIndex, endIndex })
    },

    sortableOptions() {
      return {
        item: '.menu-button-item',
        dragarea: '.menu-button-dragarea',
        sortChangedFunc: this.onSortChanged
      }
    }
  },

  template: `
    <ul
      class="menu-button-list"
      :class="{ 'menu-button-list--nested': !isRoot }"
      v-sortable="sortableOptions()"
    >
      <li
        v-for="(button, index) in buttons"
        :key="button._uid"
        class="menu-button-item"
      >
        <div
          class="menu-button-row"
          :class="{ selected: isSelected(pathForIndex(index)) }"
          @click="selectButton(pathForIndex(index))"
        >
          <button
            type="button"
            class="menu-button-remove"
            @click="removeButton(pathForIndex(index), $event)"
            aria-label="删除"
          >
            <i class="slp-trash"></i>
          </button>
          <span
            v-if="isRoot && canAddSubButton(button)"
            class="menu-button-add-sub menu-button-dragarea"
            @click="addSubButton(pathForIndex(index), $event)"
            title="添加子菜单"
          >
            <i class="slp-plus"></i>
          </span>
          <span class="menu-button-name menu-button-dragarea">{{ button.name }}</span>
        </div>
        <menu-button-list
          v-if="button.sub_button && button.sub_button.length"
          :buttons="button.sub_button"
          :selected-path="selectedPath"
          :limits="limits"
          :is-root="false"
          :parent-path="isRoot ? { rootIndex: index } : parentPath"
          @select="$emit('select', $event)"
          @remove="$emit('remove', $event)"
          @add-sub="$emit('add-sub', $event)"
          @sort="$emit('sort', $event)"
        />
      </li>
    </ul>
  `,

  components: {
    MenuButtonList: null
  },

  beforeCreate() {
    this.$options.components.MenuButtonList = this.$options
  }
}
